var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1269 5.9152C16.7429 5.4352 15.7061 4.2064 14.2661 3.0928C12.4229 1.7104 10.5989 1 8.83253 1C7.06613 1 5.24213 1.7104 3.41813 3.112C1.97813 4.2256 0.922126 5.4544 0.557326 5.9344C0.346126 6.2032 0.346126 6.568 0.557326 6.8368C0.941326 7.3168 1.97813 8.5456 3.41813 9.6592C5.26133 11.0608 7.08533 11.7712 8.83253 11.7712C10.5797 11.7712 12.4229 11.0608 14.2469 9.6592C15.6869 8.5456 16.7429 7.3168 17.1077 6.8368C17.3381 6.568 17.3381 6.184 17.1269 5.9152ZM8.83253 10.984C5.06933 10.984 1.82453 7.2016 1.17173 6.376C1.84373 5.5504 5.06933 1.768 8.83253 1.768C12.5957 1.768 15.8405 5.5504 16.4933 6.376C15.8405 7.2016 12.5957 10.984 8.83253 10.984Z",
    fill: "#AD79CD",
    stroke: "#0076B8",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83253 3.15039C7.04693 3.15039 5.60693 4.59039 5.60693 6.37599C5.60693 8.16159 7.04693 9.60159 8.83253 9.60159C10.6181 9.60159 12.0581 8.16159 12.0581 6.37599C12.0581 4.59039 10.6181 3.15039 8.83253 3.15039ZM8.83253 8.83359C7.46933 8.83359 6.37493 7.71999 6.37493 6.37599C6.37493 5.03199 7.46933 3.91839 8.83253 3.91839C10.1957 3.91839 11.2901 5.01279 11.2901 6.37599C11.2901 7.73919 10.1957 8.83359 8.83253 8.83359Z",
    fill: "#AD79CD",
    stroke: "#0076B8",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e9819d457d1a6d1a6fbd843239d73e1f.svg";
export { ForwardRef as ReactComponent };